export const toErrorObject = (errors) => {
    let e = new Map();
    /* eslint-disable array-callback-return */
    errors
        .filter(e => e.severity === "ERROR")
        .map(error => {
            if (error.fieldNames) {
                error.fieldNames.map(field => {
                    let o = e.get(field);
                    if (o) {
                        o.text = [...o.text, error.message];
                        // o.textNode = [o.textNode, React.createElement(<><br/> {error.message}</>)];
                    } else {
                        e.set(field, { text: [error.message], huText: [getMessage(error)] }) //,textNode: React.createElement( <>{error.message} </>)})
                    }
                })
            }
        });
    console.log(e);
    return e;
}

export const getMessage = (element) => {
    let m = messages.get(element.code);
    if (m) {
        return m.message;
    } else {
        return `Error happened, code: ${element.code}`
    }
}

export const messages = new Map([
    [0, { message: "Hiba történt" }],
    [100, { message: "Üres mező" }],
    [101, { message: "Ez már létezik" }],
    [102, { message: "Helytelen formátum" }],
    [103, { message: "Nincs találat" }],
    [104, { message: "Kapcsolt elemek" }],
    [105, { message: "Nem a legutolsó" }],
    [106, { message: "Már lezárva" }],
    [107, { message: "Konfliktoló dátum" }],
    [108, { message: "Már létezik ettől a naptól érvényes elem" }],
    [109, { message: "Létezik tranzakció ezzel a bankszámlaszámmal" }],
    [110, { message: "Semmi sem módosult" }],
    [111, { message: "Nem lehet üres" }],
    [112, { message: "A dátum nem lehet a jövőben" }],
    [113, { message: "Készpénzes fizetésnél a dátumoknak meg kell egyezniük" }],
    [114, { message: "Utalás opció csak az utalásos számláknál lehetséges" }],
    [115, { message: "Helytelen művelet" }],
    [116, { message: "Javasolt tranzakciók törölbe lesznek", }],
    [117, { message: "Az összeg nagyobb mint a fentmaradó összeg az elemen" }],
    [118, { message: "Helytelen művelet, a tranzakció nincs a számlához javasolva" }],
    [119, { message: "Az összeg nagyobb mint a tranzakció összege" }],
    [120, { message: "Az összeg nagyobb mint a tranzakción fennmaradó összeg" }],
    [121, { message: "A fizetési napnak 1-30 között kell lennie" }],
    [122, { message: "Fizetés státusza DRAFT-nak kell lennie" }],
    [123, { message: "A munkavállaló nem rendelkezik ezzel a letiltásos partnerrel" }],
    [133, { message: " db tranzakció már létezett" }],
    [134, { message: " db tranzakciót beolvasott" }],
    [135, { message: "Nem lehet lezárni" }],
    [138, { message: "Honnan adónem nem lehet ugyanaz mint a hova adónem" }],
    [146, { message: "Erre az évre már van elérhető szabadság felvéve" }],
    [149, { message: " db alkalmi fizetés már létezett" }],
    [150, { message: " db alkalmi fizetést beolvasott" }],
    [158, { message: "Túl hosszú mező (5000)" }],
]);